module.exports = "<app-login> \n</app-login>\n"


//////////////////
// WEBPACK FOOTER
// /home/ec2-user/PasoAgentes/PA_frontend_routemobile/src/app/auth/auth.component.html
// module id = ../../../../../src/app/auth/auth.component.html
// module chunks = auth.module